export default __webpack_public_path__ + "static/media/fitr-2.427acdeb.png";